export enum LogLevelEnum {
  FULL = 'FULL',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR'
}
